import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Dr. Martín Rossi',
    role: 'Abogado Independiente',
    text: 'Excelente material. Tenía un amparo urgente contra una prepaga por medicación oncológica y los modelos me ahorraron literalmente un día entero de trabajo. Muy bien fundamentado.',
    rating: 5
  }, {
    name: 'Dra. Laura Giménez',
    role: 'Estudio Jurídico Giménez & Asoc.',
    text: 'Compramos el tratado para el estudio y se convirtió en material de consulta diaria. La jurisprudencia está muy bien seleccionada y las estrategias procesales son súper prácticas.',
    rating: 5
  }, {
    name: 'Dr. Carlos Mendoza',
    role: 'Abogado Especialista',
    text: 'Incluso teniendo experiencia en salud, este material suma muchísimo. Sistematiza todo lo que uno necesita tener a mano. La inversión se recupera con la primera consulta que resolvés.',
    rating: 5
  }];
  return <section className="py-20 bg-legal-800" data-id="element-275">
      <div className="container mx-auto px-4" data-id="element-276">
        <div className="text-center mb-16" data-id="element-277">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-278">
            Lo que dicen nuestros colegas
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-279">
            Profesionales que ya optimizaron su trabajo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-280">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-900 p-8 rounded-xl border border-legal-700 relative" data-id="element-281">
              <div className="flex gap-1 mb-6" data-id="element-282">
                {[...Array(test.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-283" />)}
              </div>
              <p className="text-slate-300 mb-8 italic leading-relaxed" data-id="element-284">
                "{test.text}"
              </p>
              <div data-id="element-285">
                <p className="text-white font-bold" data-id="element-286">{test.name}</p>
                <p className="text-gold-500 text-sm" data-id="element-287">{test.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};